import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { PaymentColumnStructure } from "../../../Data/PaymentManagement";
import { PaymentRowType } from "../../../Types/PaymentManagement";
import { UserModalDetailsType } from "../../../Types/UserManagement";
import { SearchTableButton } from "../../../utils/Constant";
import CommonModal from "../../atoms/Common/CommonModal";
import { YesNo } from "../../molecules/Forms/YesNo"; 
import api from "../../../Api/axios"; 

export const PaymentManagementContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [tableData, setTableData] = useState<PaymentRowType[]>([]);
  const [updateRecords, setUpdateRecords] = useState(false);

  // Fetch payment data from API
  const fetchPayments = async () => {
    const res = await api.get("api/user-payment");
    setTableData(res.data.data);
  };

  useEffect(() => {
    setTableData([])
    fetchPayments();
    setUpdateRecords(false)
  }, [updateRecords]);

  const [modalDetails, setModalDetails] = useState<
    UserModalDetailsType | undefined
  >();

  const centeredToggle = () => {
    setModalDetails(undefined);
  };

  // Filter data based on any field
  const filteredItems = tableData.filter((item) => {
    item.modalDetails = setModalDetails;
    
    const lowerCaseFilterText = filterText.toLowerCase();
    
    return Object.values(item).some((val) =>
      typeof val === "string" && val.toLowerCase().includes(lowerCaseFilterText)
    );
  });

  // Sub-header component with search input
  const subHeaderComponentMemo = useMemo(
    () => (
      <Row className="w-100 d-flex justify-content-between">
        <Col
          id="API-1_filter"
          className="w-50 dataTables_filter d-flex align-items-center justify-content-center"
        >
          <Label className="me-1">{SearchTableButton}:</Label>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFilterText(e.target.value)
            }
            type="search"
            value={filterText}
            placeholder="Search by any field"
          />
        </Col>
        <Col className="w-50 d-flex justify-content-end">
        <Button onClick={() => setUpdateRecords(true)}>Refresh</Button>
          {/* You can add a button or additional filters here if needed */}
        </Col>
      </Row>
    ),
    [filterText]
  );

  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <div className="table-responsive">
            <div id="API-1" className="dataTables_wrapper">
              <DataTable
                data={filteredItems}
                columns={PaymentColumnStructure}
                striped={true}
                pagination
                className="display"
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            </div>
          </div>
          <CommonModal
            centered
            isOpen={modalDetails !== undefined}
            toggle={centeredToggle}
          >
            <div className="modal-toggle-wrapper">
              <YesNo
                centeredToggle={centeredToggle}
                onYesClick={() => {
                  console.log(modalDetails);
                }}
              />
            </div>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  );
};
